var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.playerData)?_c('div',{class:['footer-player', 'ml-1', 'hidden-xs-only']},[(_vm.$config.bandCampPlayer.use)?_c('iframe',{attrs:{"title":"bandcamp-embedded-player","seamless":"","src":_vm.makePlayerUrl}}):_c('on-page-vc-audio-player',{attrs:{"controls":_vm.controls,"max-width":"400px","album":_vm.playerData.album,"compact":true}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d062ff8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer-player.vue
// module id = null
// module chunks = 